export interface FeishuCodeReceivedPayload {
  code: string;
  platformId: string;
  state?: string;
}

const FEISHU_CSRF_KEY = "pudu-onelogin-csrf";

export function getAndPersistFeishuNonce(storage: Storage = window.sessionStorage) {
  let state = storage.getItem(FEISHU_CSRF_KEY);

  if (!state) {
    state = String(Date.now());
    storage.setItem(FEISHU_CSRF_KEY, state);
  }

  return state;
}

export function buildFeishuBridgeRedirectUri(params: {
  origin: string;
  platformId: string;
}) {
  const url = new URL("/redirect", params.origin);
  url.searchParams.set("platformid", params.platformId);
  return url.toString();
}

export function buildFeishuGotoUrl(params: {
  feishuAppId: string;
  redirectUri: string;
  state: string;
}) {
  const url = new URL(
    "https://passport.feishu.cn/suite/passport/oauth/authorize"
  );
  url.searchParams.set("client_id", params.feishuAppId);
  url.searchParams.set("redirect_uri", params.redirectUri);
  url.searchParams.set("response_type", "code");
  url.searchParams.set("state", params.state);
  return url.toString();
}

export function buildFeishuIframeSrc(gotoUrl: string, tmpCode: string) {
  const url = new URL(gotoUrl);
  url.searchParams.set("tmp_code", tmpCode);
  return url.toString();
}

export function parseRedirectPayload(searchParams: URLSearchParams) {
  return {
    code: searchParams.get("code") ?? "",
    state: searchParams.get("state") ?? "",
    platformId: searchParams.get("platformid") ?? "",
  };
}

export function isFeishuCallbackStateValid(
  expectedState: string,
  actualState?: string
) {
  return Boolean(expectedState && actualState && expectedState === actualState);
}
